import { memo } from "react";
// import remarkGfm from "remark-gfm";
// import remarkMath, { Options } from "remark-math";
// import rehypeKatex from "rehype-katex";
import ReactMarkdown from "react-markdown";
// import "property-information";

// const remarkMathOptions: Options = {
//   singleDollarTextMath: false,
// };

export const Markdown = memo(({ message }: { message: string }) => {
  return (
    <ReactMarkdown
      // remarkPlugins={[remarkGfm, [remarkMath, remarkMathOptions]]}
      // rehypePlugins={[rehypeKatex]}
      children={message}
    ></ReactMarkdown>
  );
});
